import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Grid, Button, Stack } from '@mui/material';

import { tabsData } from './utils/tabsData';
import PaymentsTab from './components/Payments';
import { invoiceStyles } from './styles/styles';
import { SET_SELECTED_ITEM } from 'store/actions';
import WatchlistTab from './components/Watchlist';
import Credentials from './components/Credentials';
import { useCustomMediaQuery } from 'hooks/useMediaQuery';
import { useAuth } from 'hooks/useAuth';
import LockedFeature from 'components/LockedFeature';
import UploadPaymentsFileTab from './components/PaymentsFileUpload';
import UploadInvoicesFileTab from './components/InvoicesFileUpload';

const Invoice = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { user } = useAuth();
    const selectedTab = useSelector((state) => state.me.selectedItems);
    const classes = invoiceStyles({ isMobileScreen: useCustomMediaQuery('(max-width:600px)') });
    const companyData = useSelector((state) => state.company.data);
    
    const hasAccess = companyData?.is_invoice_reconciler;

    const changeTab = (tab) => {
        dispatch(SET_SELECTED_ITEM(tab.label));
        navigate(`${tab.path}`);
    };

    const getTabButtonStyle = (tabLabel) => ({
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: selectedTab === tabLabel ? '600' : '500',
        backgroundColor: selectedTab === tabLabel ? '#CEEFDF' : 'transparent',
        borderRadius: selectedTab === tabLabel ? '3px' : 'none',
        color: selectedTab === tabLabel ? '#0A8C4D' : '#6C727F',
    });

    useEffect(() => {
        const currentPath = location.pathname;
        const currentTab = tabsData.find((tab) => currentPath == tab.path);
        if (currentTab && currentTab.label !== selectedTab) {
            dispatch(SET_SELECTED_ITEM(currentTab.label));
        } else if (!currentTab && tabsData.length > 0) {
            dispatch(SET_SELECTED_ITEM(tabsData[0].label));
            navigate(`${tabsData[0].path}`);
        }
    }, [location.pathname, dispatch, selectedTab, tabsData, navigate]);

    if (!hasAccess) {
        return (
            <LockedFeature 
                featureName="Invoice Reconciler"
                upgradeText="Upgrade to the Invoice Reconciler plan to access all invoice management features."
                buttonText="Upgrade Now"
            />
        );
    }

    return (
        <Grid container>
            <Grid padding={1} sx={classes.tabsListContainer}>
                <Stack
                    gap={1}
                    display="flex"
                    alignItems="center"
                    sx={classes.stackStyles}
                    width={{ xs: '100%', md: 'fit-content' }}
                    flexDirection={{ xs: 'column', md: 'row' }}
                >
                    {tabsData.map((tab) => (
                        <Grid
                            item
                            key={tab.label}
                            style={{
                                borderRadius: '5px',
                            }}
                        >
                            <Button
                                onClick={() => changeTab(tab)}
                                style={getTabButtonStyle(tab.label)}
                                variant={selectedTab === tab.label ? 'contained' : 'text'}
                            >
                                {tab.label}
                            </Button>
                        </Grid>
                    ))}
                </Stack>
            </Grid>

            <Grid item xs={12} sx={classes.tabsContainer}>
                {selectedTab === 'Payments' && <PaymentsTab />}
                {selectedTab === 'Watchlist' && <WatchlistTab />}
                {selectedTab === 'Credentials' && <Credentials />}
                {selectedTab === 'Payments Upload' && <UploadPaymentsFileTab />}
                {selectedTab === 'Invoices Upload' && <UploadInvoicesFileTab />}
            </Grid>
        </Grid>
    );
};

export default Invoice;
